export default __webpack_public_path__ + "static/media/favoriteFasting.48e99ebf.svg";